var map = {
	"./504.webp": 42738,
	"./appeal.png": 58641,
	"./attachment.svg": 33174,
	"./candidate.svg": 82281,
	"./career.png": 12823,
	"./conducted.svg": 10127,
	"./contract.png": 85935,
	"./discipline.png": 82102,
	"./employees.png": 61127,
	"./exit.png": 64768,
	"./grievance.png": 15578,
	"./leave.png": 10568,
	"./payroll.png": 8354,
	"./pdf.png": 20209,
	"./question.svg": 88299,
	"./rbm.png": 16638,
	"./recruitment.png": 36686,
	"./reporting.png": 920,
	"./structure.png": 95765,
	"./talent.png": 36029,
	"./test.svg": 87037,
	"./training.png": 11648,
	"./voting.png": 53974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38354;